module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c010daca9c3de0d95f304e3c64c120c0.png";